<template>
  <span class="ml-2">
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          @click.native="copyText(valor)"
          :color="valor != copiado ? 'primary' : 'success'"
          dark
          
          v-bind="attrs"
          v-on="on"
        >
        {{  copiado  ? 'mdi-check':   'mdi-content-copy'   }}
        </v-icon>
      </template>
      <span>{{  copiado ? "Copiado" : "Copiar" }}</span>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  props: {
    valor: {
      type: String,
      required: true,
      default:null
    },
  },
  data() {
    return {
      copiado: false,
    };
  },
  methods: {
   async  copyText(text) {
      await navigator.clipboard.writeText(text);

      this.copiado = true;
      setTimeout(() => {
        this.copiado = false;
      }, 1500);
    },
  },
};
</script>